import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { ReactNode, useMemo, MouseEvent } from "react";

const allowedSchemes = ["http:", "https:", "mailto:", "tel:"];

interface SafeLinkProps {
  attributes?: { [key: string]: string };
  children: ReactNode;
  href: string;
}

export const SafeLink = ({ attributes, children, href }: SafeLinkProps) => {
  const safeHref = useMemo(() => {
    let parsedUrl: URL = null;
    try {
      parsedUrl = new URL(href);
      // eslint-disable-next-line no-empty
    } catch {}
    if (parsedUrl && allowedSchemes.some((schema) => parsedUrl.protocol.startsWith(schema))) {
      return parsedUrl.href;
    }
    return "about:blank";
  }, [href]);

  const handleLinkClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(safeHref, "_blank");
  };

  return (
    <Tooltip
      color="white"
      title={
        <a href={safeHref} onClick={handleLinkClick}>
          <FontAwesomeIcon fixedWidth size="lg" icon={["far", "external-link-alt"]} />
        </a>
      }
    >
      <a href={safeHref} {...attributes} rel="nofollow">
        {children}
      </a>
    </Tooltip>
  );
};
